import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  legalService,
  CreateLegalAcceptanceRequest,
  LegalAcceptanceResponse,
} from '@aslanpay/portal-common-lib';

const useCreateLegalAcceptance = ({
  onSuccess,
  onError,
}: UseMutationOptions<LegalAcceptanceResponse, Error, CreateLegalAcceptanceRequest>) => {
  return useMutation<LegalAcceptanceResponse, Error, CreateLegalAcceptanceRequest>(
    (createLegalAcceptanceRequest: CreateLegalAcceptanceRequest) =>
      legalService.createLegalAcceptance(createLegalAcceptanceRequest),
    { onSuccess, onError }
  );
};

export default useCreateLegalAcceptance;
